import { ArrowRightIcon } from '@heroicons/react/20/solid';

const CTA2 = (ctaProps: any) => {
  if (ctaProps.style === 'action') {
    if (ctaProps.link) {
      return (
        <a
          href={
            ctaProps.link.type === 'external'
              ? ctaProps.link.external
              : ctaProps.link.internal
          }
          target={ctaProps.link.type === 'external' ? '_blank' : '_self'}
        >
          <button
            type="button"
            className="max-w-fit inline-flex items-center gap-x-1.5 rounded-md bg-blue-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          >
            {ctaProps.link.label}
            <ArrowRightIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
          </button>
        </a>
      );
    }
  }
  if (ctaProps.style === 'link') {
    if (ctaProps.link) {
      return (
        <a
          className="max-w-fit"
          href={
            ctaProps.link.type === 'external'
              ? ctaProps.link.external
              : ctaProps.link.internal
          }
          target={ctaProps.link.type === 'external' ? '_blank' : '_self'}
        >
          {ctaProps.link.label}
          <ArrowRightIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
        </a>
      );
    }
  }
  return null;
};

export default CTA2;
